export default __webpack_public_path__ + "static/media/p2.5eac0165.png";